/* eslint-disable */
<template>
  <div>
    <section class="pedido-steps" v-if="!form_success">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="return d-block d-sm-none">
              <router-link :to="route">
                <img :src="require('@/assets/img/backspace.svg')" alt="backspace" class="mb-5">
              </router-link>
            </div>
            <div class="section-title">
              <h4>Edición de Cuota {{ data.id }}</h4>
              <img class="d-none d-sm-block" @click="cancelCuota" :src="require('@/assets/img/backspace.svg')" alt="backspace">
            </div>
            <p class="subtitulo">En esta sección puede editar la cuota</p>
          </div>
        </div>
        <form method="GET" id="form-id">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" id="sku">
                <label>SKU
                  <Tooltip :parent="'sku'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <select name="sku" v-model="data.sku" disabled v-if="this.country === 'Argentina'">
                  <option>{{ data.sku }}</option>
                </select>
                <select name="sku" v-model="data.sku" disabled v-if="this.country !== 'Argentina'">
                  <option>{{ data.sku }}</option>
                </select>
                <span class="required-span" v-if="this.errorsForm.sku">El SKU es obligatorio</span>
              </div>
            </div>

            <div class="col-md-6" v-if="this.country === 'Mexico'">
              <div class="form-group" id="channels">
                <label>Channel
                  <Tooltip :parent="'channels'" :message="'Canal de Venta en Mccain.'">?</Tooltip>
                </label>
                <select name="zone" v-model="data.zone" disabled>
                  <option>{{ data.zone }}</option>
                </select>
                <span class="required-span" v-if="this.errorsForm.zone">El channel es obligatorio</span>
              </div>
            </div>

            <div class="col-md-6" v-if="this.country === 'Calatin'">
              <div class="form-group" id="client">
                <label>Cliente
                  <Tooltip :parent="'client'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <select name="client" v-model="data.sold_to_name" disabled>
                  <option>{{ data.sold_to_name }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6" v-if="this.country === 'Calatin'">
              <div class="form-group" id="plant">
                <label>Planta
                  <Tooltip :parent="'plant'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <select name="plant" v-model="data.plant_id" disabled>
                  <option>{{ data.plant_id }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6" v-if="this.country === 'Argentina'">
              <div class="form-group" id="zone">
                <label>Región
                  <Tooltip :parent="'zone'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <select name="client" v-model="data.zone" disabled>
                  <option>{{ data.zone }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6" v-if="this.country === 'Argentina'">
              <div class="form-group" id="vendedor">
                <label>Vendedor
                  <Tooltip :parent="'vendedor'" :message="'Número de identificación interno Mccain.'">?</Tooltip>
                </label>
                <select name="vendedor" disabled>
                  <option>{{ data.vendedor }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group" id="start_date">
                <label>Fecha de Inicio
                  <Tooltip :parent="'start_date'" :message="'Fecha de inicio de la cuota.'">?</Tooltip>
                </label>
                <Datepicker
                    v-model="data.start_date"
                    name="start-date"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    disabled
                    utc="preserve"
                />
                <span class="required-span" v-if="this.errorsForm.start_date">{{ this.errorsForm.start_date[0] }}</span>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group" id="final_date">
                <label>Fecha Final
                  <Tooltip :parent="'final_date'" :message="'Fecha final.'">?</Tooltip>
                </label>
                <Datepicker
                    v-model="data.final_date"
                    name="final-date"
                    :enableTimePicker="false"
                    textInput
                    autoApply
                    format="dd/MM/yyyy"
                    inputClassName="dp-input-custom"
                    required
                    utc="preserve"
                />
                <span class="required-span" v-if="this.errorsForm.final_date">{{ this.errorsForm.final_date[0] }}</span>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group" id="form-group-quantity">
                <label>Cantidad
                  <Tooltip :parent="'quantity'" :message="'Cantidad de sku máximo permitidos para la compra.'">?
                  </Tooltip>
                </label>
                <input type="text" id="quantity" name="quantity" v-model="data.quantity">
                <span class="required-span" v-if="this.errorsForm.quantity">La cantidad es obligatoria.</span>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group" id="form-group-availability">
                <label>Disponible
                  <Tooltip :parent="'availability'" :message="'Disponible para compra.'">
                  </Tooltip>
                </label>
                <input type="text" disabled id="availability" name="availability" v-model="data.availability">
              </div>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12 next-btn d-none d-md-block">
            <a href="javascript:void(0)" @click="submitForm()" class="btn-green">Guardar</a>
            <a @click="cancelCuota()" href="javascript:void(0)" class="btn-white">Cancelar</a>
          </div>
            <!-- Botones para dispositivos pequeños -->
            <div class="col-12 next-btn d-block d-md-none mb-3">
              <a href="javascript:void(0)" @click="submitForm()" class="btn-green" style="margin-right: auto; margin-left: auto;">Guardar</a>
            </div>

            <div class="col-12 next-btn d-block d-md-none mb-3">
              <a @click="cancelCuota()" href="javascript:void(0)" class="btn-white" style="margin-right: auto; margin-left: auto;">Cancelar</a>
            </div>

            <div class="loading d-none"></div>
        </div>
      </div>
    </section>
  </div>
  <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert"/>
</template>

<script>
import {route} from '@/enviroment';
import axios from 'axios';
import $ from 'jquery';
import Tooltip from '../../snippets/Tooltip.vue';

export default {
  name: 'CuotaEdicion',
  props: {
    country: String,
    selectedCuota: Object
  },
  data: function () {
    return {
      route: route,
      data: {},
      cuota: Object,
      errorsForm: this.defaultFieldsValues(),
      submit_disabled: false,
      form_success: false,
      alertVisible: false
    }
  },
  components: {
    Tooltip
  },
  async created() {
    await this.initCuota();
  },
  methods: {
    initCuota() {
      this.cuota = this.selectedCuota;
      switch (this.country) {
        case 'Argentina':
          this.data = {
            id: this.cuota.ID,
            ID: this.cuota.ID,
            ean: this.cuota.ean,
            sku: this.cuota.SKU,
            cliente: this.cuota.cliente,
            zone: this.cuota.zona_nombre,
            zona_nombre: this.cuota.zona_nombre,
            vendedor: this.cuota.vendedor,
            quantity: this.cuota.Cajas,
            Cajas: this.cuota.Cajas,
            availability: this.cuota.disponible,
            disponible: this.cuota.disponible,
            Fecha_inicio: this.cuota.Fecha_inicio.substring(0, 10),
            Fecha_final: this.cuota.Fecha_final.substring(0, 10),
            start_date: this.cuota.Fecha_inicio.substring(0, 10),
            final_date: this.cuota.Fecha_final.substring(0, 10),
            cuota_original: this.cuota.Cajas
          };
          break;
        case 'Calatin':
          this.data = {
            id: this.cuota.id,
            sku: this.cuota.sku,
            sold_to: this.cuota.sold_to,
            sold_to_name: this.cuota.sold_to_name,
            plant_id: this.cuota.plant_id,
            quantity: this.cuota.quantity,
            availability: this.cuota.availability,
            start_date: this.cuota.start_date.substring(0, 10),
            final_date: this.cuota.final_date.substring(0, 10)
          };
          break;
        case 'Mexico':
          this.data = {
            id: this.selectedCuota.id,
            sku: this.selectedCuota.sap,
            sap: this.selectedCuota.sap,
            zone: this.selectedCuota.zone,
            quantity: this.selectedCuota.quantity,
            availability: this.selectedCuota.availability,
            start_date: this.selectedCuota.start_date.substring(0, 10),
            final_date: this.selectedCuota.final_date.substring(0, 10)
          };
          break;
        default:
          this.data = {};
          break;
      }
    },
    submitForm() {
      this.mostrarCarga();
      this.submit_disabled = true;
      // eslint-disable-next-line
      axios.put(`/cuotificador/cuota/${this.data.id}`, Object.fromEntries(Object.entries(this.data).filter(([k, v]) => v)))
          .then(async (res) => {
            if (res.status === 200 && res.data.status === 'success') return res.data.data;
            else throw new Error(res.data.message);
          })
          .then(async (data) => {
            if (data.status.toString() === 'error') throw new Error(data.message);
            this.errorsForm = this.defaultFieldsValues();
            this.cuota = data.cuota;
            this.$emit("updateCuota", this.cuota);
            this.$emit("ocultarEdicion", false);
            this.ocultarCarga();
          })
          .catch((error) => {
            let msg = '';
            if (error.status && error.status === 200) msg = error.message;
            else msg = error;
            this.alertVisible = true;
            this.showAlert('warning', 'Atención!', msg);
            this.ocultarCarga();
          })
          .finally(() => {
            this.submit_disabled = false;
          });
    },
    async cancelCuota() {
      const confirmed = await this.cancelConfirm();
      if (!confirmed) return;
      this.$emit("ocultarEdicion", false);
    },
    async cancelConfirm() {
      return await this.$vbsModal.confirm({
        title: "Cancelar edición de cuota",
        message: "¿Está seguro? Se perderán los cambios realizados.",
        leftBtnText: 'No',
        rightBtnText: 'Si',
        displayCloseBtn: false
      });
    },
    showAlert(type, title, message) {
      if(this.alertVisible){
        this.$refs.alert.showAlert(
            type,
            message,
            title,
            {
              iconSize: 35,
              iconType: 'solid',
              position: 'top right',
            }
        );
        this.$refs.alert.$el.style.display = 'block';
        this.hideAlert();
      }
    },
    hideAlert(){
      setTimeout(() => {
          this.$refs.alert.$el.style.display = 'none';
          this.alertVisible = false
        }, 5000);  // 5 segundos y se borra
    },
    mostrarCarga() {
      $('.loading').removeClass('d-none');
      $('#mostrarTablaPedidos').addClass('d-none');
    },
    ocultarCarga() {
      $('.loading').addClass('d-none');
      $('#mostrarTablaPedidos').removeClass('d-none');
    },
    defaultFieldsValues() {
      return {
        quantity: '',
        final_date: ''
      }
    }
  },
}
</script>